import Actions from '../../odata/actions';

const actions = new Actions('packingList', 'packingLists');

export default actions;
